<div class="cont-result-hotels" [class.top]="isTopClass$ | async">

  <ng-container *ngIf="(isMobile$ | async) === false">
    <div class="search-bar-edit-cont">
      <div class="back-cont">
        <div class="back-btn" (click)="back()">
          <app-ds-icon
            [icon]="icons.ChevronLeft"
            [size]="16"
            [color]="iconFillColor.Primary">
          </app-ds-icon>
          <app-ds-typography
            [size]="fontSize.XXS"
            [tag]="'p'"
            [fontFamily]="fontFamily.SemiBold"
            [color]="fontColor.Primary"
            [text]="'BACK' | transloco">
          </app-ds-typography>
        </div>
      </div>
      <app-hotel-search
        [isResults]="true"
        [source]="currentSource"
        [searchType]="searchType"
        [loadSearchData]="(loadingResults$ | async)">
      </app-hotel-search>
    </div>
    <div class="wrapper">
      <div class="head-result-hotel">
        <div class="cont-title">
          <h2 *ngIf="placeTitleSelection$ | async as placeTitleSelection">
            {{ 'HOTELS_MODULE.RESULT_HOTELS.TITLE' | transloco }} {{ placeTitleSelection }}
          </h2>
          <span *ngIf="hotelSearchResultTotalCount$ | async">
            {{ resultsLabel(hotelSearchResultTotalCount$ | async) }}
          </span>
        </div>
        <div class="head-options">
          <div class="map-toggle">
            <app-ds-tab
              [type]="tabType"
              [options]="[
                {
                  Icon: icons.List
                },
                {
                  Icon: icons.Location
                }
              ]"
              [defaultOption]="showResultsMap ? 1 : 0"
              [justUseIcon]="true"
              (selectTab)="toggleShowResultsMap()">
            </app-ds-tab>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="!showResultsMap; else resultsMap">
    <div class="wrapper">
      <div class="cont-results">
        <div *ngIf="(isMobile$ | async) === false as isNotMobile" class="cont-filters">
          @if (isLoadingHotelFilters$ | async) {
            <app-product-filters-placeholder></app-product-filters-placeholder>
          } @else {
            <app-map-widget
              [isLoading]="loadingResults$ | async"
              [markers]="getCityMarker(hotelResults$ | async)"
              (mapClick)="toggleShowResultsMap()">
            </app-map-widget>
            <app-refundable-widget
              [isLoading]="loadingResults$ | async"
              [isDesktop]="isNotMobile"
              [checked]="checkRefundable$ | async"
              (searchHotelsWithFilter)="applyFilter($event, isNotMobile)">
            </app-refundable-widget>
          }
          <app-hotels-filters #hotelFilters
            *ngIf="hasMoreThanOneResult$ | async"
            [pickedStars]="pickedStars$ | async"
            [pickedCheckboxes]="pickedCheckboxes$ | async"
            [pickedTotalDiscountPercentage]="pickedTotalDiscountPercentage$ | async"
            [pickedRanges]="pickedRanges$ | async"
            [pickedSorter]="pickedSorter$ | async"
            [hotelNameSearch]="hotelNameSearch$ | async"
            [filters]="hotelFilters$ | async"
            [sorters]="(hotelFiltersResponse$ | async)?.Sorters"
            [isLoading]="isLoadingHotelFilters$ | async"
            [hotelNights]="totalNightsNumber$ | async"
            [exclusiveOffer]="exclusiveOfferFilter$ | async"
            [hourType]="hourType$ | async"
            [isByHours]="isByHours"
            (filter)="applyFilter($event, isNotMobile)"
            (sorter)="applySorter($event)">
          </app-hotels-filters>
        </div>
        <ng-container *ngIf="isMobile$ | async">
          <ng-container *ngIf="(errorInHotels$ | async) === false">
            <app-marriott-store-hero [branchCode]="branchCode"></app-marriott-store-hero>
            <div class="float-filter-bar" *ngIf="(isLoadingHotelFilters$ | async) === false">
              <div class="result-title-section">
                <ng-container *ngIf="!isByHours; else titleByhours">
                  <app-ds-icon
                    [icon]="icons.Hotels"
                    [size]="28"
                    [color]="iconFillColor.Primary">
                  </app-ds-icon>
                  <span>{{ 'HOTEL_FILTER_BAR.RESULTS_DATA_INFO.HOTEL_RESULTS.SELECT_YOUR_HOTEL' | transloco }}</span>
                </ng-container>
                <ng-template #titleByhours>
                  <span>{{ 'HOTEL_FILTER_BAR.RESULTS_DATA_INFO.HOTEL_RESULTS.SELECT_YOUR_ROOM_BYHOURS' | transloco }}</span>
                </ng-template>
              </div>
              <div class="results-filter-bar-sect" [class.sticky]="stickyFilterBar">
                <app-hotel-filter-bar
                  [viewType]="filtersProvider"
                  [isSticky]="stickyFilterBar"
                  [hourType]="hourType$ | async"
                  (viewFilters)="activeFilter()">
                </app-hotel-filter-bar>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="(loadingResults$ | async) === false; else resultsPlaceholder">
          <ng-container *ngIf="emptyResults$ | async; else viewResults">
            <section [class.results-hotels]="(isMobile$ | async) === false">
              <app-no-results
                [top]="'80'"
                [error]="errors$ | async"
                [searchType]="searchType"
                [source]="source">
                <ng-container *ngIf="(isMobile$ | async) === false">
                  <ng-container *ngTemplateOutlet="selectedFiltersTemplate; context: { isMobile: false }"></ng-container>
                </ng-container>
              </app-no-results>
            </section>
          </ng-container>
          <ng-template #viewResults>
            <section
              #list
              class="results-hotels"
              infiniteScroll
              [infiniteScrollDistance]="6"
              [infiniteScrollThrottle]="350"
              [fromRoot]="true"
              (scrolled)="scrollResults()">
              <ul>
                <li
                  [class.isByHours]="isByHours"
                  *ngFor="let hotel of (hotelResults$ | async); trackBy: trackByIdx; index as hotelIndex; first as isFirst; last as isLast"
                  [id]="'hotel-' + hotel?.HotelCode">
                  <ng-container *ngIf="isFirst">
                    
                    <ng-container *ngIf="(isMobile$ | async) === false">
                      <ng-container *ngTemplateOutlet="selectedFiltersTemplate; context: { isMobile: false }"></ng-container>
                    </ng-container>

                    <ng-container *ngIf="searchedHotel$ | async; else notSearchedHotel">
                      <ng-container *ngTemplateOutlet="typeHotelResult; context: { hotel: searchedHotel$ | async, hotelIndex: hotelIndex, highlight: true }"></ng-container>
                      <ng-container *ngIf="!isLast">
                        <div #hotelDiscover>
                          <div class="header-results-list-cont" *ngIf="(exclusiveOffer$ | async) === false">
                            <span>{{'HOTELS_MODULE.RESULT_HOTELS.DISCOVER' | transloco : { destination: hotel.Destination | placeName : headerListCriteria | async } }}</span>
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngTemplateOutlet="exclusiveOffers; context: { isSearchedHotel: true }"></ng-container>
                    </ng-container>
                    
                    <ng-template #notSearchedHotel>
                      <ng-container *ngIf="isNotSearchedHotel">
                        <app-not-searched-hotel
                          [isMobile]="isMobile$ | async"
                          [hotelName]="hotelName"
                          [checkIn]="checkIn$ | async"
                          [checkOut]="checkOut$ | async"
                          (editSearch)="toggleSearchPanel()">
                        </app-not-searched-hotel>
                        <div class="header-results-list-cont" *ngIf="(exclusiveOffer$ | async) === false">
                          <span>{{'HOTELS_MODULE.RESULT_HOTELS.OTHER_ACCOMMODATIONS' | transloco : { destination: hotel.Destination | placeName : headerListCriteria | async } }}</span>
                        </div>
                      </ng-container>
                      <ng-container *ngTemplateOutlet="exclusiveOffers; context: { isSearchedHotel: hotelName }"></ng-container>
                    </ng-template>

                    <ng-template #exclusiveOffers let-isSearchedHotel="isSearchedHotel">
                      <ng-container *ngIf="exclusiveOffer$ | async">
                        <div
                          [ngClass]="{'exclusive-offers-search-hotel': isSearchedHotel, 'exclusive-offers': !isSearchedHotel}" 
                          [class.exclusive-offers-cont]="isSearchedHotel">
                          <app-hotels-exclusive-offer
                            [hasRappiCard]="hasRappiCard$ | async"
                            [isPrime]="isPrime$ | async"
                            [isMobile]="isMobile$ | async"
                            [source]="source"
                            (showDetail)="navigateToHotelDetail($event)"
                            (filter)="viewMembersRateOffer($event)">
                          </app-hotels-exclusive-offer>
                          <h2>
                            {{'HOTELS_MODULE.RESULT_HOTELS.HOTELS_IN' | transloco : { destination: hotel.Destination | placeName : headerListCriteria | async } }}
                          </h2>
                        </div>
                      </ng-container>
                    </ng-template>

                  </ng-container>

                  <ng-container *ngIf="showResultItem$(hotel) | async">
                    <ng-container *ngTemplateOutlet="typeHotelResult; context: { hotel: hotel, hotelIndex: hotelIndex, highlight: false, hotelDiscover: !!(searchedHotel$ | async)}"></ng-container>
                  </ng-container>
                </li>
              </ul>
            </section>
          </ng-template>
        </ng-container>
      </div>
    </div>
  </ng-container>
  
  <ng-container *ngIf="showMobileFilters$ | async">
    <div class="cont-filters-mobile" [class.is-hotel-in-map-selected]="isFilterUp">
      <app-ds-chip-filter
        [priority]="chipFilterPriority"
        [options]="[
          {
            Label: 'HOTELS_MODULE.RESULT_HOTELS.' + (!showResultsMap ? 'MAP' : 'LIST') | transloco,
            Icon: !showResultsMap ? icons.Location : icons.List
          }
        ]"
        (clickEvent)="toggleShowResultsMap()">
      </app-ds-chip-filter>
      <app-btn-top-action
        [position]="topActionPosition"
        (topAction)="topAction()">
      </app-btn-top-action>
    </div>
  </ng-container>
</div>

<ng-template #bannerRappicard let-i='i'>
  <div *ngIf="showRappiCardBanner(i,isMobile$ | async)" class="content-banner-rappicard" [class.isDesktop]="(isMobile$ | async) === false">
    <app-banner-results
      [bannerContainer]="bannerContainer"
      [type]="hotelTypeBanner"
      [enabled]="hotelsBannerEnabled"
      [percentages]="hotelsBannerPercentages"
      [isMobile]="isMobile$ | async"
      [parentClass]="!showSelectedFilters(hasFilters$ | async, searchPayload$ | async) ? 'hotel-desktop' : ''">
    </app-banner-results>
  </div>
</ng-template>

<ng-template #resultsMap>
  <div class="content-result-map">
    <app-results-map appAppearMap
      [isRouterOutletMap]="false"
      [roomsKey]="rooms"
      [appearMapIsMobile]="isMobile$ | async"
      [nearestIata]="(destinationHotelPlace$ | async)?.NearestIata"
      (closeMap)="toggleShowResultsMap()"
      (viewFiltersOnMap)="activeFilter()">
    </app-results-map>
  </div>
</ng-template>

<ng-template #resultsPlaceholder>
  <div class="container-loading-mobile" *ngIf="isMobile$ | async; else desktopPlaceholder">
    <ng-container *ngIf="isLoadingHotelFilters$ | async">
      <app-travel-loader></app-travel-loader>
    </ng-container>
  </div>
  <ng-template #desktopPlaceholder>
    <div class="result-placeholder__container">
       <app-product-results-placeholder
         [isMobile]="isMobile$ | async" [quantity]="5">
       </app-product-results-placeholder>
     </div>
  </ng-template>
</ng-template>

<div class="wrapper" *ngIf="isMobile$ | async">
  <div class="search-bar-results">
    <app-swipe-up
      [showSwipeUp]="editSearchIsActivated$ | async"
      [classType]="swipeStyle"
      [height]="100"
      [title]="'TITLE_SEARCH_HOME' | transloco"
      [showHeader]="true"
      (toggleShowSwipeUp)="toggleSearchPanel()">
      <ng-container content>
        <div class="content">
          <app-hotel-search
            *ngIf="!isByHours; else searchByhours"
            [isResults]="true"
            [showSearch]="editSearchIsActivated$ | async"
            [searchType]="searchType"
            [isMobile]="isMobile$ | async"
            [loadSearchData]="(loadingResults$ | async)"
            [source]="currentSource"
            (showMobileCalendarEvent)="showMobileCalendar($event)"
            (redirectToSearch)="redirectToSearch()">
          </app-hotel-search>
          <ng-template #searchByhours>
            <app-byhours-search
              [isResults]="true"
              [showSearch]="editSearchIsActivated$ | async"
              [searchType]="searchType"
              [isMobile]="isMobile$ | async"
              [loadSearchData]="(loadingResults$ | async)"
              [source]="currentSource"
              (redirectToSearch)="redirectToSearch()"
              (showMobileCalendarEvent)="showMobileCalendar($event)">
            </app-byhours-search>
          </ng-template>
        </div>
      </ng-container>
    </app-swipe-up>
  </div>
</div>

<ng-container *ngIf="isMobile$ | async">
  <router-outlet name="outlet"
    (activate)="onActivate($event)"
    (deactivate)='onDeactivate($event)'>
  </router-outlet>
</ng-container>

<ng-template #selectedFiltersTemplate let-isMobile='isMobile'>
  <ng-container *ngIf="(errorInHotels$ | async) === false">
    <div class="sel-filter-cont-hotel" *ngIf="showSelectedFilters(hasFilters$ | async, searchPayload$ | async)" selectedFilters>
      <app-selected-hotel-filters
        [isMobile]="isMobile"
        [filters]="hotelFilters$ | async"
        [hasRappiCard]="hasRappiCard$ | async"
        [isPrime]="isPrime$ | async"
        [source]="source"
        (remove)="applyFilter($event, isMobile)">
      </app-selected-hotel-filters>
    </div>
  </ng-container>
</ng-template>

<ng-template #widgetsTemplate let-isMobile='isMobile' let-i='i'>
  <app-widgets-container *ngIf="(isLoadingHotelFilters$ | async) === false"
    [type]="hotelsWidgetType"
    [index]="i"
    [pickedCheckboxes]="(pickedCheckboxes$ | async)"
    [widgets]="selectWidgets(i)"
    [isByHours]="isByHours"
    (showFiltersEvent)="activeFilter()"
    (searchHotelsWithFilter)="applyFilter($event, isMobile)">
  </app-widgets-container>
</ng-template>

<ng-template #typeHotelResult let-hotel='hotel' let-hotelIndex='hotelIndex' let-highlight="highlight" let-hotelDiscover="hotelDiscover">
  <ng-container *ngIf="(isMobile$ | async) === false; else mobile">
    <ng-container *ngTemplateOutlet="bannerRappicard; context: { i: hotelIndex }"></ng-container>
    <app-type-result
      [hotel]="hotel"
      [small]="false"
      [hotelIndex]="hotelIndex"
      [highlight]="!!highlight"
      [params]="params$ | async"
      (showDetail)="navigateToHotelDetail($event)"
      [isMobile]="false"
      [isLoggedIn]="isLoggedIn$ | async"
      [isInternational]="isInternational$ | async"
      [hasRappiCard]="hasRappiCard$ | async"
      [isPrime]="isPrime$ | async"
      [source]="source"
      [searchBy]="searchBy"
      (viewFinancialPartners)="toggleFinancialPartners($event)">
    </app-type-result>
  </ng-container>
  <ng-template #mobile>
    <ng-container  *ngIf="hotelDiscover; else notDiscover">
      <ng-container *ngTemplateOutlet="resultMobile"></ng-container>
      <ng-container *ngTemplateOutlet="bannerRappicard; context: { i: hotelIndex }"></ng-container>
      <ng-container *ngTemplateOutlet="resultWidget"></ng-container>
    </ng-container>
    <ng-template #notDiscover>
      <ng-container *ngTemplateOutlet="bannerRappicard; context: { i: hotelIndex }"></ng-container>
      <ng-container *ngTemplateOutlet="resultWidget"></ng-container>
      <ng-container *ngTemplateOutlet="resultMobile"></ng-container>
    </ng-template>
    
    <ng-template #resultMobile>
      <app-type-result-mobile
        [params]="params$ | async"
        [hotel]="hotel"
        [source]="source"
        [highlight]="!!highlight"
        [isInternational]="isInternational$ | async"
        [hasRappiCard]="hasRappiCard$ | async"
        [isPrime]="isPrime$ | async"
        [isLoggedIn]="isLoggedIn$ | async"
        [searchBy]="searchBy"
        [isByhours]="isByHours"
        (showDetail)="navigateToHotelDetail($event)"
        (resetTooltips)="resetTooltips($event)"
        (viewFinancialPartners)="toggleFinancialPartners($event)">
      </app-type-result-mobile>
    </ng-template>

    <ng-template #resultWidget>
      <ng-container *ngTemplateOutlet="widgetsTemplate; context: { isMobile: isMobile$ | async, i: hotelIndex }"></ng-container>
    </ng-template>

  </ng-template>

  <app-financial-partners
    [totalPrice]="financialPartnersInfo?.totalPrice"
    [searchBy]="searchBy"
    [maxAmount]="financialPartnersInfo?.maxAmount"
    [showSwipeUp]="showFinancialPartners"
    [isDesktop]="(isMobile$ | async) === false"
    (closeModal)="toggleFinancialPartners()">
  </app-financial-partners>  
</ng-template>
